import Comment from './Comment'
import CommentContianer from './CommentContainer'

export default CommentContianer(Comment)
